import React from 'react'

interface PauseIconProps {
  size: string
  color: string
  onClick?: () => void;
}

const getCssVar = (varName: string): string =>
  getComputedStyle(document.documentElement).getPropertyValue(varName).trim()

const PauseIcon: React.FC<PauseIconProps> = ({size, color, onClick}) => {
  const fillColor = getCssVar(color)

  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      onClick={onClick}
    >
      <g id='Media / Pause_Circle'>
        <path
          id='Vector'
          d='M14 9V15M10 9V15M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z'
          stroke={fillColor}
          stroke-width='2'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
    </svg>
  )
}

export default PauseIcon
